let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Q0UC"), load("borwc")]).then(() => parcelRequire('jhdHU'));